import { createContext } from 'react';

import { IDeviceLinkContextProviderHooks } from 'features/device/providers/device-link-provider/hooks';

export const DeviceLinkContext = createContext({} as IDeviceLinkContextProviderHooks);
